<template>
  <div>
    <a class="c-btn c-btn--blue u-w280">
      <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <use
            xlink:href="/assets/img/sprite.svg#flag"
          />
        </svg>
      </div>
      <p class="c-btn__text">{{ text }}</p>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
}
</script>
